import React, {useState} from 'react';
import styled from 'styled-components';
import { setLSRegion } from '@/store/ls/region';
import { IRegion } from '@/types/region';
import RadioBox from '../ui/Radio';

interface IModalSelectRegionProps {
  onClose: () => void;
  regions: IRegion[];
  region: IRegion;
  setRegion: (region) => void;
}

export default function ModalSelectRegion({
  onClose, regions, region, setRegion
}: IModalSelectRegionProps) {

  const [ filter, setFilter ] = useState('');

  const handleRegion = (region) => {
    setRegion(region);
    setLSRegion(region);
    window.location.reload();
  }

  const handleFilter = (e) => {
    setFilter(e.target.value);
  }

  const filteredRegions = regions.filter(item => item.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0)

  return <Container>
    <CloseCart onClick={onClose}>Закрыть</CloseCart>
    <Title>
      Выберите регион
    </Title>
    <SearchRegion type="text" placeholder="Введите регион поиска" value={filter} onChange={handleFilter} />
    <RadioButtons>
      {filteredRegions.map((item, index) => <RadioBox key={index} value={item.id} checked={+region.id === +item.id} onChange={()=>handleRegion(item)} name="region">
        {item.name}
      </RadioBox>)}
      
    </RadioButtons>
    
  </Container>
}

const SearchRegion = styled.input`
  border-radius: 4px;
  border: 1px solid var(--green);
  height: 35px;
  padding: 0 10px;
  margin-bottom: 15px;
  width: 100%;
  box-sizing: border-box;
`

const RadioButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  font-size: 16px;
  padding: 15px 5px 15px 5px;
  text-align: left;

  > div {
    margin-bottom: 9px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 100%;

    & > div:not(:last-child) {
      margin-bottom: 20px;
    }
  } 
`

const CloseCart = styled.a`
  position: absolute;
  right: 0;
  top: -40px;
  color: var(--color-text-invert);
  padding: 10px;

  @media (max-width: 480px) {
    color: var(--green);
    top: -6px;
  }
`

const Container = styled.div`
  position: relative;
  padding: 30px 20px;
  text-align: center;
  background-color: var(--color-bg);
  width: 800px;
  max-width: calc(100% - 80px);
  border-radius: 20px;
  color: var(--color-title);
  line-height: var(--line-height-normal);

  @media (max-width: 480px) {
    width: 100%;
    max-width: 100%;
    padding: 30px 20px;
    max-height: 100%;
    overflow-y: scroll;
  }
`
const Title = styled.h2`
  font-size: var(--text-title);
  text-transform: uppercase;
  font-family: var(--font-semibold);
  color: var(--color-title);
  margin: 0 0 40px;

  & span {
    color: var(--green);
  }

  @media (max-width: 480px) {
    font-size: 22px;
    margin-bottom: 20px;
  }
`
